<template>
  <div class="overflow-x-auto">
    <table class="w-full">
      <slot />
    </table>
  </div>
</template>
